import {z} from 'zod';

import {MAX_NOTE_LENGTH} from '../constants';
import {
  getMaximumExpiryDate,
  getMinimumExpiryDate,
  getOffsetExpiry,
} from '../expiryFunctions';

export const linkSchema = z.object({
  id: z.string(),
  userId: z.string(),
  email: z.email(),
  expiry: z.coerce.date(),
  created: z.coerce.date(),
  permissions: z.object({
    reports: z.boolean(),
    downloads: z.boolean(),
  }),
  invitedBy: z
    .object({
      id: z.string(),
      name: z.string(),
      thumbnail: z.string(),
    })
    .nullable(),
});

export const createLinkSchema = z.object({
  emails: z.email().array().min(1, 'At least one email is required.'),
  expiry: z.iso.date().refine(
    (d) => {
      const date = getOffsetExpiry(d); // comes out of input with no timezone
      const minDate = getMinimumExpiryDate();
      const maxDate = getMaximumExpiryDate();
      return date >= minDate && date <= maxDate;
    },
    {
      error: 'Expiry date must be between 1 and 60 days from today.',
    }
  ),
  permissions: z.object({
    reports: z.boolean(),
    presentations: z.boolean(),
    downloads: z.boolean(),
  }),
  presentationId: z.string().nullable(),
  note: z.string().max(MAX_NOTE_LENGTH),
});
// export const editLinkSchema = z.object({
//   // projectId: z.string(),
//   // expiry: z.string().datetime(),
//   // email: z.string().email(),
//   shouldEnforceIp: z.boolean(),
//   permissions: z.object({
//     reports: z.boolean(),
//     downloads: z.boolean(),
//   }),
// });
